<template>
  <main class="admin-team__main"> 
    <div class="employes">
      <div v-if="error">
        <p>Factura no encontrada</p>
      </div>
      <div v-else class="header-invoice">
        <div class="invoice-state">
          <span>Estado</span>
          <div class="state-info"> Abierta </div>
        </div>
        <div class="invoice-state">
          <span>Factura</span>
          <div class="invoice-id"> Abierta </div>
        </div>
        <!-- <div class="invoice-info"> -->
        <!--   <span></span> -->
        <!--   <div class="state-id"></div> -->
        <!-- </div> -->
      </div>

      <div v-if="!error" class="loans">
        <payment :key="invoice.id" v-for="payment in invoice.payments"
                                   :total="payment.total"
                                   :id="payment.id"
                                   :date="payment.created_at"
                                   />
      </div>

      <div v-if="!error" class="notes">
        <p> <strong>Notas:</strong> </p>
        <textarea> 
          {{ invoice.note }} 
        </textarea>
      </div>
    </div>
  </main>
</template>


<script>
import configService from '../settings/api-url'
import payment from '../components/invoices/payment.vue'
export default {
  data (){
    return {
      invoice: {},
      error: false
    }
  },
  components: {
    payment
  },
  async created () {
    let { data } = await configService('admin/invoices/' + this.$route.params.id)
    console.log(data.error)
    debugger
    if  (data.error === 'invoice not found') {
      this.error = true
    } else {
      this.invoice = data
    }
  }
}
</script>
